export default "__VITE_ASSET__S8goJBRE__"